import React, { Fragment } from 'react';
import man from '../../../assets/images/dashboard/user.png'
import { Link } from 'react-router-dom';
import { Edit } from 'react-feather';
import {ELANA,GeneralManager} from '../../../constant'

const UserPanel = () => {
    const url = '';
    return (
        <Fragment>
            <div className="sidebar-user text-center">
                <div>
                    <img className="img-60 rounded-circle lazyloaded blur-up" src='/assets/images/Logo.jpg'  alt="#" />
                  
                </div>
                <h6 className="mt-3 f-14">Smart Shop</h6>
                <p>{GeneralManager}.</p>
            </div>
        </Fragment>
    );
};

export default UserPanel;